import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import BreedingEventFields from "./BreedingEventFields";
import { 
	getBreedingEventDetails, doBreedingEventCreate, doBreedingEventUpdate 
} from "../../../../redux/breedingevent/breedingEventState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { FormatDateValue } from "../../../../utils/index";

const BreedingEventForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, userDetails, ...props}) => {
	const { recordId, mode } = props;  	
	const [form] = useForm();
	
	useEffect(() => {		
		getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { mating_date, ...restData } = recordData;
			const initialValues = {
				mating_date: mating_date ? FormatDateValue(mating_date) : null,
				...restData				
			};
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {
			formData.mating_date = formData.mating_date ? formData.mating_date.format('YYYY-MM-DD') : null;
			formData.id = recordId ?? 0;
			formData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<BreedingEventFields recordData={recordData} mode={mode} form={form} isAdmin={true}/>

				<CrudButtons baseRoute="/console/breeding-events" mode={mode} recordId={recordId}/>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.breedingEvent.details?.data,
	requesting: state.breedingEvent.details?.requesting,
	success: state.breedingEvent.details?.succcess,
	userDetails: state.breedingEvent.details?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getBreedingEventDetails(id)),
	doCreate: (data) => dispatch(doBreedingEventCreate(data)),
	doUpdate: (data) => dispatch(doBreedingEventUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreedingEventForm);